import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpClient } from '@angular/common/http';
import { Idle } from '@ng-idle/core';

import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

@Injectable()
export class PingInterceptor implements HttpInterceptor {

    constructor(private httpClient: HttpClient, private idle: Idle) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        this.idle.interrupt();
        const skipUrl = ['/api/auth/extendSession', '/api/users/activate']
        if (skipUrl.includes(req.url)) {
            return next.handle(req);
        }

        const raw = sessionStorage.getItem('ping_session_last_checked');
        const last_checked = (raw != null && raw !== 'null') ? Number(raw) || 0 : 0;
        const now = Date.now();
        const ONE_MINUTES = 1 * 60 * 1000;
        const extendSession = last_checked === 0 || (last_checked > 0 && last_checked < now - ONE_MINUTES);
        if (extendSession) {
            this.httpClient.get('/api/auth/extendSession').pipe(take(1)).subscribe({
                next: (sessionExtendTime) => {
                    const last_checked_updated = sessionExtendTime ? Number(sessionExtendTime) : now;
                    sessionStorage.setItem('ping_session_last_checked', String(last_checked_updated));
                },
                error: (err) => {
                    console.error('PingInterceptor: extendSession failed', err);
                    // Reset on error so the next request can retry
                    sessionStorage.removeItem('ping_session_last_checked');
                }
            });
        }

        return next.handle(req);
    }
}